<template>
    <dialog-modal :show="showModal" @close="closeModal">
        <template #title>
            {{ $t("users.create.title") }}
        </template>

        <template #content class="bg-gray-50">
            <airtable-selector
                :errors="errors.airtable_record_id"
                key-name="name"
                type="contacts"
                @input="handleAirtableRecord"
            />
            <tenant-selector v-model="selectedTenant" :errors="errors.tenant_id" :tenants="tenants"></tenant-selector>
        </template>

        <template #footer>
            <div class="flex">
                <button-secondary
                    class="mr-auto"
                    button-style="danger"
                    :enabled="!isSubmitting"
                    @click="cancelCreate"
                    >{{ $t("users.buttons.cancel") }}</button-secondary
                >
                <button-primary :show-loading-indicator="isSubmitting" :enabled="!isSubmitting" @click="createUser">{{
                    $t("users.buttons.new")
                }}</button-primary>
            </div>
        </template>
    </dialog-modal>
</template>

<script>
import { computed, ref } from "vue";
import { Inertia } from "@inertiajs/inertia";
import ButtonPrimary from "@/Components/ButtonPrimary";
import DialogModal from "@/Jetstream/DialogModal";
import AirtableSelector from "@/Components/AirtableSelector";
import ButtonSecondary from "../../Components/ButtonSecondary";
import TenantSelector from "../../Components/TenantSelector";

export default {
    name: "UserCreate",
    components: {
        TenantSelector,
        ButtonSecondary,
        ButtonPrimary,
        DialogModal,
        AirtableSelector,
    },
    props: {
        tenants: Array,
        preselectedTenant: String,
        errorBags: Object,
        showModal: Boolean,
    },
    emits: ["close-modal"],
    setup(props, { emit }) {
        const isSubmitting = ref(false);
        const selectedTenant = ref(props.preselectedTenant ? props.preselectedTenant : "");
        const airtableRecord = ref("");

        const createUser = () => {
            Inertia.post(
                route("universal.users.store"),
                {
                    tenant_id: selectedTenant.value,
                    airtable_record_id: airtableRecord.value,
                },
                {
                    onStart: () => {
                        isSubmitting.value = true;
                    },
                    onFinish: () => {
                        isSubmitting.value = false;
                    },
                }
            ).then(() => {
                emit("close-modal");
            });
        };

        const errors = computed(() => (props.errorBags.default ? props.errorBags.default : {}));

        const handleAirtableRecord = (value) => {
            airtableRecord.value = value;
        };
        const closeModal = () => {
            emit("close-modal");
        };

        const cancelCreate = () => {
            closeModal();
        };

        return {
            errors,
            selectedTenant,
            airtableRecord,
            isSubmitting,
            handleAirtableRecord,
            cancelCreate,
            createUser,
        };
    },
};
</script>
